export const isArray =
  Array.isArray ||
  function (obj) {
    return Object.prototype.toString.apply(obj) === '[object Array]'
  }

export function getAllUrlParameters(url: string) {
  // 2. 通过 "?" 分割 URL
  var queryString = url.split('?')[1]

  // 3. 如果没有查询字符串，返回空对象
  if (!queryString) {
    return {}
  }

  // 4. 将查询字符串分割成键值对数组
  var pairs = queryString.split('&')

  // 5. 创建一个对象来存储结果
  var result: Record<string, string> = {}

  // 6. 遍历键值对
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=')
    var key = decodeURIComponent(pair[0])
    var value = decodeURIComponent(pair[1] || '')

    // 7. 将键值对添加到结果对象中
    result[key] = value
  }

  // 8. 返回包含所有参数的对象
  return result
}